var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,{tag:"component",attrs:{"value":_vm.values,"inline":false,"multiple":""},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }